import { isEmpty } from 'lodash-es';
import { yyEva } from 'yyeva';
import { _anly_seng_custom } from '../../store/Action';

window.isReport = false;

export default async function (options) {
  let player;
  if (isEmpty(options)) {
    !window.isReport &&
      _anly_seng_custom('webgl_error', {
        data: {
          content: '您的设备不支持 webgl，无法展示动效!!!',
          msg: `${options?.src ?? ''}播放失败 -- 2`,
        },
      }); // mp4 播放异常
    window.isReport = true; // 避免重复上报
    throw new Error('your options is empty');
  } else {
    let newOptions = {};
    newOptions.videoUrl = options.src;
    newOptions.renderType = 'webgl';
    newOptions.logLevel = 'error';
    newOptions.useMetaData = true; // 兼容vap
    newOptions.mode = 'AspectFit'; // 填充方式
    newOptions.loop = false; // 是否循环
    newOptions.mute = false; // 是否静音
    newOptions.checkTimeout = true; // 检测播放超时
    newOptions.endPause = false; // 播放完毕后是否暂停, 传true的话，清理时，需要外部调用destroy释放资源
    newOptions.onStart = () => {
      // 强制手动再次设置一遍音频是否静音
      if (player?.video) {
        player.video.muted = newOptions.mute;
      }
    };
    newOptions.onEnd = () => {
      if (player.destroy && !newOptions.endPause) {
        player.destroy();
      }
    };
    newOptions.onError = (...args) => {
      console.log('play error: ', options.src);
      _anly_seng_custom('webgl_error', {
        data: {
          ...args,
          msg: `${options?.src ?? ''}播放失败 -- 1`,
        },
      }); // mp4 播放异常
    };
    newOptions = { ...newOptions, ...options };
    if (!canWebGL()) {
      newOptions.renderType = 'canvas';
      console.log('设备不支持WebGl');
    }
    player = await yyEva(newOptions);

    return player;
  }
}

// 是否支持 webgl
export function canWebGL() {
  let isCanWebGL;
  if (typeof isCanWebGL !== 'undefined') {
    return isCanWebGL;
  }
  try {
    if (!window.WebGLRenderingContext) {
      return false;
    }
    const canvas = document.createElement('canvas');
    let context =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    isCanWebGL = !!context;
    context = null;
  } catch (err) {
    isCanWebGL = false;
  }
  return isCanWebGL;
}
